import React from "react";
import ContentLoader from "react-content-loader";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function HomeMeeting(props) {
    const { t } = useTranslation();
    const demo_data = [{ id: 1 }, { id: 2 }, { id: 3 }];
    const selector = useSelector((state) => state.upcomingMeetingReducer);

    return (
        <>
        {!selector?.loading && selector?.data?.length > 0 ? (
        <div className="widget widget-meeting-history mb-4">
            <h4>{t('Meetings')}</h4>
            <div className="overflow-hidden">
                <div className="meeting-history">
                    <ul className="list-group list-group-flush">
                        {selector?.loading && demo_data?.map((post, i) => (
                            <li key={i} className="list-group-item widget-item-list">
                                <ContentLoader
                                    speed={2}
                                    width={400}
                                    height={60}
                                    viewBox="0 0 400 60"
                                    backgroundColor="#eeecec"
                                    foregroundColor="#eae6e6"
                                    {...props}
                                >
                                    <circle cx="31" cy="31" r="15" />
                                    <rect x="58" y="18" rx="2" ry="2" width="140" height="10" />
                                    <rect x="58" y="34" rx="2" ry="2" width="140" height="10" />
                                </ContentLoader>
                            </li>
                        ))}
                        {!selector?.loading && selector?.data?.map((value, index) => (
                            <li className="list-group-item" key={value.id ?? index}>
                                <div className="upcoming-meeting-list d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <div className="upcoming-meeting-date_time">
                                            <h2 className="upcoming-meeting-date">{value.day}</h2>
                                            <p className="upcoming-meeting-month">{value.month}</p>
                                            <p className="upcoming-meeting-time">{value.time}</p>
                                        </div>

                                        <div className="upcoming-meeting-content ms-2">
                                            <h4 className="upcoming-meeting-title d-flex align-items-center gap-2">
                                                <Link to={`/meeting-details/${value.room_name}`}>{value.room_title}</Link>
                                                {/* Live Now badge \u2014 updates in real-time via Soketi */}
                                                {value.is_start == 1 && (
                                                    <span
                                                        className="badge rounded-pill d-inline-flex align-items-center px-2 py-1"
                                                        style={{
                                                            fontSize: '9px',
                                                            fontWeight: '600',
                                                            backgroundColor: 'rgba(34,197,94,0.12)',
                                                            color: '#16a34a',
                                                            border: '1px solid rgba(34,197,94,0.3)',
                                                        }}
                                                    >
                                                        <span style={{
                                                            display: 'inline-block',
                                                            width: '5px', height: '5px',
                                                            borderRadius: '50%',
                                                            backgroundColor: '#22c55e',
                                                            marginRight: '4px',
                                                            animation: 'pulse 1.5s infinite',
                                                        }} />
                                                        Live
                                                    </span>
                                                )}
                                            </h4>
                                            <div className="upcoming-meeting-user-list">
                                                <div className="upcoming-meeting-user-img">
                                                    <ul>
                                                        <>
                                                        {value.users.slice(0, 3).map((user, index) => (
                                                            <li key={user.id}>
                                                                <Link to={`/contact/${user.id}`}>
                                                                    <div
                                                                        className="user-picture-30 rounded-circle"
                                                                        style={{ background: `url(${user.avatar})` }}
                                                                    />
                                                                </Link>
                                                            </li>
                                                        ))}
                                                        </>
                                                        {value.users.length > 3 ?
                                                            <li>
                                                                <Link to={`/meeting-details/${value.room_name}`}>
                                                                    <div className="upcoming-meeting-user-count">+{value.users.length - 3}</div>
                                                                </Link>
                                                            </li>
                                                        : ''}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Quick-join button \u2014 only visible when meeting is live */}
                                    {value.is_start == 1 && (
                                        <Link
                                            to={`/meeting/${value.room_name}`}
                                            className="btn btn-sm rounded-pill px-3 py-1 ms-2"
                                            style={{
                                                fontSize: '11px',
                                                fontWeight: '600',
                                                backgroundColor: '#22c55e',
                                                color: '#fff',
                                                whiteSpace: 'nowrap',
                                            }}
                                        >
                                            {t('Join')}
                                        </Link>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
        ) : ''}
        </>
    );
}